import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { PageHeader, Button, notification, Spin } from "antd";
import { reverse } from "named-urls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { userEditSaga } from "./saga";
import * as selectors from "./selectors";
import routes from "../../../../../routes";
import AddUserForm from "../../../../forms/AddUserForm";
import schema from "../../../../schemas/addUserSchema";

const UserEdit = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: userEditSaga });
  const dispatch = useDispatch();
  const { companyId, userId } = useParams();
  const history = useHistory();

  useEffect(() => {
    dispatch(actions.fetchUserDetails({ id: userId }));
    //dispatch(actions.fetchCompanyDetails({ id: companyId }));
    dispatch(actions.fetchCompanyPickupAddress({ id: companyId, query: "" }));
    dispatch(actions.fetchCompanyBillingAddress({ id: companyId, query: "" }));
  }, [dispatch, userId, companyId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const user = useSelector(selectors.selectUserDetails) || {};
  const companyPickupAddress = useSelector(
    selectors.selectCompanyPickupAddress
  );
  const companyBillingAddress = useSelector(
    selectors.selectCompanyBillingAddress
  );
  const loading = useSelector(selectors.selectLoading);
  const updatingUser = useSelector(selectors.selectUpdatingUser);
  const error = useSelector(selectors.selectError);

  useEffect(() => {
    if (error && error !== "") {
      notification.error({
        message: "Error Updating User",
        description: error,
      });
      setTimeout(() => {
        dispatch(actions.initializeError());
      }, 1500);
    }
  }, [error, dispatch]);
  //const companyDetails = useSelector(selectors.selectCompanyDetails) || {};

  const { pickupAddress = [], billingAddress = [] } = user;
  /*  const [remainingPickupAddress, setRemainingPickupAddress] = useState([]);
  const [remainingBillingAddress, setRemainingBillingAddress] = useState([]); */

  const handleBack = () => {
    history.goBack();
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phone: user.phone,
      pickupAddress: user.pickupAddress,
      billingAddress: user.billingAddress,
      company: user.company?._id,
      department: user.department,
      designation: user.designation,
    },
  });

  useEffect(() => {
    reset(user);

    const allPickup = pickupAddress.map((addr) => addr._id);
    const allBilling = billingAddress.map((addr) => addr._id);
    setValue("pickupAddress", allPickup);
    setValue("billingAddress", allBilling);
  }, [reset, user, setValue, pickupAddress, billingAddress]);

  const handleSuccess = () => {
    notification.success({
      message: "User Edited Successfully",
    });
    history.push(
      reverse(routes.backOffice.companies.details.users.view, {
        companyId,
        userId,
      })
    );
  };

  const handleFailure = () => {
    console.log("An error occured");
  };

  const onSubmit = (data) => {
    const payload = {
      onSuccess: () => handleSuccess(),
      id: userId,
      data,
      onFailure: () => handleFailure(),
    };
    dispatch(actions.updateUser(payload));
  };

  const handleRoleSelect = (val) => {
    if (val === "company_admin") {
      const allPickup = companyPickupAddress.map((addr) => addr._id);
      const allBilling = companyBillingAddress.map((addr) => addr._id);
      setValue("pickupAddress", allPickup);
      setValue("billingAddress", allBilling);
    } else {
      setValue("pickupAddress", []);
      setValue("billingAddress", []);
    }
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="Edit User Details"
        onBack={handleBack}
        subTitle={`${user.firstName} ${user.lastName || ""}`}
        extra={[
          <Button
            key="1"
            type="primary"
            disabled={updatingUser}
            loading={updatingUser}
            onClick={handleSubmit(onSubmit)}
          >
            Update
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        {loading ? (
          <div
            style={{
              maxWidth: "100vw",
              height: "60vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <AddUserForm
            pickupAddress={companyPickupAddress}
            billingAddress={companyBillingAddress}
            control={control}
            errors={errors}
            edit={true}
            handleRoleSelect={handleRoleSelect}
          />
        )}
      </div>
    </div>
  );
};

export default UserEdit;
